export const mockClients = [
  {
    id: 1,
    name: "Elif Kaya",
    phone: "+90 532 111 2233",
    service: "Doğum Haritası",
    consultationType: "Yazılı",
    startDate: "2026-03-18",
    deliveryDate: "2026-03-24",
    status: "Tamamlandı",
    avatar: "EK",
    notes: "Venüs dönüşü analizi istedi",
  },
  {
    id: 2,
    name: "Mert Demir",
    phone: "+90 555 987 6543",
    service: "Sinastri",
    consultationType: "Sesli",
    startDate: "2026-03-22",
    deliveryDate: "2026-03-29",
    status: "Planlandı",
    avatar: "MD",
    notes: "Çift uyum analizi",
  },
  {
    id: 3,
    name: "Selin Arslan",
    phone: "+90 542 444 5566",
    service: "Yıllık Öngörü",
    consultationType: "Yazılı",
    startDate: "2026-03-20",
    deliveryDate: "2026-03-27",
    status: "Ödeme Bekliyor",
    avatar: "SA",
    notes: "2026 yılı genel görünüm",
  },
  {
    id: 4,
    name: "Ahmet Yılmaz",
    phone: "+90 533 222 3344",
    service: "Solar Return",
    consultationType: "Sesli",
    startDate: "2026-03-24",
    deliveryDate: "2026-03-31",
    status: "Yeni Başvuru",
    avatar: "AY",
    notes: "Güneş dönüşü + transitleri",
  },
  {
    id: 5,
    name: "Zeynep Çelik",
    phone: "+90 544 333 4455",
    service: "Rektifikasyon",
    consultationType: "Yazılı",
    startDate: "2026-03-21",
    deliveryDate: "2026-03-28",
    status: "Planlandı",
    avatar: "ZÇ",
    notes: "Kesin doğum saati belirsiz",
  },
  {
    id: 6,
    name: "Caner Öztürk",
    phone: "+90 531 555 7788",
    service: "Horary",
    consultationType: "Günlük",
    startDate: "2026-03-24",
    deliveryDate: "2026-03-24",
    status: "Planlandı",
    avatar: "CÖ",
    notes: "Kariyer sorusu",
  },
  {
    id: 7,
    name: "Ayşe Şahin",
    phone: "+90 546 666 8899",
    service: "Geçmiş Yaşam ve Karmalar",
    consultationType: "Yazılı",
    startDate: "2026-03-19",
    deliveryDate: "2026-03-26",
    status: "Ödeme Bekliyor",
    avatar: "AŞ",
    notes: "Karma bağları analizi",
  },
  {
    id: 8,
    name: "Burak Koç",
    phone: "+90 538 777 9900",
    service: "İlişki Analizi",
    consultationType: "Sesli",
    startDate: "2026-03-23",
    deliveryDate: "2026-03-30",
    status: "Yeni Başvuru",
    avatar: "BK",
    notes: "Uzun süreli ilişki sorunu",
  },
  {
    id: 9,
    name: "Nilüfer Aktaş",
    phone: "+90 551 888 0011",
    service: "Astrocartography",
    consultationType: "Yazılı",
    startDate: "2026-03-17",
    deliveryDate: "2026-03-23",
    status: "Gecikti",
    avatar: "NA",
    notes: "Taşınma bölgesi analizi",
  },
  {
    id: 10,
    name: "Tarık Bulut",
    phone: "+90 539 999 1122",
    service: "Eleksiyon",
    consultationType: "Yazılı",
    startDate: "2026-03-22",
    deliveryDate: "2026-03-29",
    status: "Planlandı",
    avatar: "TB",
    notes: "İş kurma için uygun tarih",
  },
  {
    id: 11,
    name: "Pınar Güneş",
    phone: "+90 530 121 3344",
    service: "Doğum Haritası",
    consultationType: "Yazılı",
    startDate: "2026-03-24",
    deliveryDate: "2026-03-31",
    status: "Yeni Başvuru",
    avatar: "PG",
    notes: "Detaylı natal analiz",
  },
  {
    id: 12,
    name: "Kerem Aydın",
    phone: "+90 543 232 4455",
    service: "Sinastri",
    consultationType: "Yazılı",
    startDate: "2026-03-16",
    deliveryDate: "2026-03-22",
    status: "Tamamlandı",
    avatar: "KA",
    notes: "Evlilik uyumu",
  },
];
